import { render, staticRenderFns } from "./TipoEmpresaCard.vue?vue&type=template&id=49e9bda8&scoped=true&"
import script from "./TipoEmpresaCard.vue?vue&type=script&lang=js&"
export * from "./TipoEmpresaCard.vue?vue&type=script&lang=js&"
import style0 from "./TipoEmpresaCard.vue?vue&type=style&index=0&id=49e9bda8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e9bda8",
  null
  
)

export default component.exports